<template>
  <a-card class="style1">
    <h3 class="pb-2">Settings</h3>

    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="General">
        <a-form :form="form" :label-col="isDesktop ? { span: 8 } : {}" :wrapper-col="isDesktop ? { span: 16 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
          <a-row>
            <a-col :md="{ span: 11, offset: 1 }">
              <a-form-item :label="$t('label.supportEmail')">
                <a-input v-decorator="['SUPPORT_EMAIL']" />
              </a-form-item>
            </a-col>
            <a-col :md="{ span: 11, offset: 1 }">
              <a-form-item :label="$t('label.designerEmail')">
                <a-input v-decorator="['DESIGNER_EMAIL']" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row type="flex" justify="end">
            <a-col>
              <a-form-item>
                <a-button type="primary" class="tf-btn tf-btn-primary" style="width: 200px;" html-type="submit" :loading="isLoading">{{ $t('button.updateSettings') }}</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-tab-pane>

      <a-tab-pane key="2" tab="Instruction Videos">
        <a-table :loading="isLoading" :columns="columns" :data-source="videoData" bordered rowKey="id">
          <template v-for="col in ['rtitle', 'rslug', 'rurl']" :slot="col" slot-scope="text, record">
            <div :key="col">
              <a-input v-if="record.editable" style="margin: -5px 0;" :value="text" @change="e => handleChange(e.target.value, record.id, col)" />
              <template v-else>
                {{ text }}
              </template>
            </div>
          </template>
          <div slot="preview_video" slot-scope="text, record" class="text-center">
            <a @click="e => openInstructionVideo(record.url)" v-if="record.video_type === 'embedded'">
              <a-icon type="play-circle" theme="filled" :style="{ fontSize: '24px' }" />
            </a>
          </div>
          <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations text-center">
              <span v-if="record.editable">
                <a @click="() => save(record.id)">Save</a>
                <a @click="() => cancel(record.id)">Cancel</a>
              </span>
              <span v-else>
                <a :disabled="editingKey !== ''" @click="() => edit(record.id)">Edit</a>
              </span>
            </div>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { empty } from '@/utils';
import { mapActions, mapState } from 'vuex';

import { isEmpty } from 'lodash';
import ConfigService from '@/services/ConfigService';

const columns = [
  {
    title: 'Title',
    dataIndex: 'title',
    width: '25%',
    scopedSlots: { customRender: 'rtitle' },
  },
  {
    title: 'Slug',
    dataIndex: 'slug',
    width: '15%',
    scopedSlots: { customRender: 'rslug' },
  },
  {
    title: 'Link',
    dataIndex: 'url',
    width: '40%',
    scopedSlots: { customRender: 'rurl' },
  },
  {
    title: 'Preview',
    dataIndex: 'preview_url',
    key: 'preview',
    scopedSlots: {
      customRender: 'preview_video',
    },
  },
  {
    title: '',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export default {
  data() {
    this.cacheData = [];
    return {
      videoData: [],
      columns,
      editingKey: '',
      isLoading: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'admin_settings',
    });
  },
  computed: {
    ...mapState(['settings', 'user']),
    ...mapState({
      configVars: state => state.settings.configVars,
      instructionVideos: state => state.settings.instructionVideos,
    }),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  /* eslint-disable */
  async mounted() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading = false;
    }

    this.videoData = this.instructionVideos;
    this.cacheData = this.videoData.map(item => ({ ...item }));

    this.$nextTick(() => {
      this.form.setFieldsValue(this.configVars);
    });
  },
  methods: {
    empty,
    ...mapActions({
      openInstructionVideo: 'openInstructionVideo',
    }),
    async doInitData() {
      if (isEmpty(this.configVars)) {
        await this.$store.dispatch('fetchConfig');
      }
      if (isEmpty(this.instructionVideos)) {
        await this.$store.dispatch('fetchInstructionVideos');
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      if (!this.form.isFieldsTouched()) {
        return;
      }

      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            await ConfigService.doSetConfig({
              vars: values,
            });
            this.$store.commit('CHANGE_SETTING', { setting: 'configVars', value: values });
            this.$notification['success']({
              message: 'You have updated settings successfully!',
            });
          } catch (ex) {
            console.log(ex);
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
    handleChange(value, key, column) {
      const newData = [...this.videoData];
      const target = newData.find(item => key === item.id);
      if (target) {
        target[column.substring(1, column.length)] = value;
        this.videoData = newData;
      }
    },
    edit(key) {
      const newData = [...this.videoData];
      const target = newData.find(item => key === item.id);
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.videoData = newData;
      }
    },
    async save(key) {
      const newData = [...this.videoData];
      const newCacheData = [...this.cacheData];
      const target = newData.find(item => key === item.id);

      await ConfigService.doUpdateInstructionVideo(target);
      const targetCache = newCacheData.find(item => key === item.id);

      if (target && targetCache) {
        delete target.editable;
        this.videoData = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = '';

      this.$store.dispatch('updateInstructionVideos', newData);
    },
    cancel(key) {
      const newData = [...this.videoData];
      const target = newData.find(item => key === item.id);
      this.editingKey = '';
      if (target) {
        Object.assign(
          target,
          this.cacheData.find(item => key === item.id),
        );
        delete target.editable;
        this.videoData = newData;
      }
    },
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>
